export default __webpack_public_path__ + "static/media/call_bg.45d59f19.jpg";